import React, { Dispatch, FC, ReactElement, SetStateAction, SyntheticEvent, useState } from 'react';
import get from 'lodash/get';

import Button, { BUTTON_SIZES, BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import LoadingSpinner, {
  SIZES
} from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import EmailSendFailure from 'buyside/components/presentation/Subscribe/EmailSendFailure';
import { proHome } from 'buyside/util/urlHelper';

import { CreateEmailMutationFn, Mailer } from 'interfaces/graphql-typings';

export type RequestMoreInfoProps = { createEmail: CreateEmailMutationFn };

const makeOnClick = (
  createEmail: CreateEmailMutationFn,
  {
    setCreateEmailFailed,
    setCreateEmailSuccessMsg,
    setIsLoading
  }: {
    setCreateEmailFailed: Dispatch<SetStateAction<boolean>>;
    setCreateEmailSuccessMsg: Dispatch<SetStateAction<string>>;
    setIsLoading: Dispatch<SetStateAction<boolean>>;
  }
): ((e: SyntheticEvent) => void) => async (): Promise<void> => {
  setIsLoading(true);

  createEmail({ variables: { mailerName: Mailer.research_access } })
    .then((data): void => {
      setIsLoading(false);
      const success = get(data, ['data', 'createEmail', 'success']);
      if (success) {
        setCreateEmailSuccessMsg('Successfully sent email to access@sumzero.com.');
        setTimeout((): void => {
          window.location.assign(proHome());
        }, 3000);
      } else {
        setCreateEmailFailed(true);
      }
    })
    .catch((): void => {
      setIsLoading(false);
      setCreateEmailFailed(true);
    });
};

const RequestMoreInfo: FC<RequestMoreInfoProps> = ({ createEmail }): ReactElement => {
  const [createEmailFailed, setCreateEmailFailed] = useState(false);
  const [createEmailSuccessMsg, setCreateEmailSuccessMsg] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const shouldBtnShow = !createEmailSuccessMsg && !isLoading && !createEmailFailed;
  return (
    <>
      {shouldBtnShow && (
        <Button
          text="Contact us"
          onClick={makeOnClick(createEmail, {
            setIsLoading,
            setCreateEmailSuccessMsg,
            setCreateEmailFailed
          })}
          type={BUTTON_TYPES.MAJOR}
          size={BUTTON_SIZES.SMALL}
          isLoading={isLoading}
          inherit
          analyticsTag="request-more-info"
        />
      )}
      {isLoading && <LoadingSpinner size={SIZES.TINY} />}
      {createEmailSuccessMsg && <span>{createEmailSuccessMsg}</span>}
      {createEmailFailed && <EmailSendFailure />}
    </>
  );
};

export default RequestMoreInfo;
